// extracted by mini-css-extract-plugin
module.exports = {"salutation":"TeamHeader_salutation__Lg19E","phone":"TeamHeader_phone__5Dadl","mobile-phone":"TeamHeader_mobile-phone__oEg1_","socials":"TeamHeader_socials__jEVsO"};